export default {
  props: {
    title: {
      type: String,
    },
    items: {
      type: Array,
    },
    button: {
      type: Object,
    },
  },

  components: {
    hotCardFeature: () => import('~/components/Molecules/CardFeature/CardFeature.vue'),
  },
}
